import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table, Button, Form, Dropdown } from "semantic-ui-react";
import { darken } from "polished";

export const Container = styled.div`
  /* width: 100vw;
  min-height: 100vh;
  background: #ffffff; */
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;

  color: #000000;

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  display: inline-block;
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const Image = styled.img`
  height: 5rem;
  width: auto;
`;

export const Label = styled.label`
  color: ${(props) => `${props.color}`};

  display: block;
  margin: 0 0 0.28571429rem;
  font-size: 0.92857143em;
  font-weight: 700;
  text-transform: none;
`;
export const Field = styled.div`
  width: ${(props) => props.width || "100%"};
  margin-top: 30px;
  display: block;

  & > div {
    margin-top: 10px;
  }
`;

export const StyledForm = styled(Form)`
  border: 1px solid #cecece !important;
  padding: 16px !important;
  border-radius: 4px !important;
  margin-bottom: 16px;
`;

export const StyledButton = styled(Button)`
  position: relative;
  margin: 0 16px !important;
  border-radius: 4px !important;

  :first-child {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
`;

export const ExcludeButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 16px;
  width: 20px !important;
  height: 20px !important;
  color: #fff;
  background-color: #db2828;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.1s all ease-in-out !important;

  * {
    margin: -4px 0 0 0 !important;
  }

  :hover {
    width: 22px !important;
    height: 22px !important;
    background-color: ${darken("0.05", "#db2828")};
  }
`;

export const StyledDropdown = styled(Dropdown)`
  /* margin-bottom: 16px !important; */
`;

export const CreatedInscritoContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #cecece;
  border-radius: 4px;
  padding: 8px;

  margin-bottom: 24px;

  *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const LineContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledLabel = styled.div`
  font-weight: 600;
  width: 250px;
  display: flex;
  justify-content: flex-start;
`;

export const StyledLineContent = styled.div`
  font-weight: 400;
  width: max-content;
  display: flex;
  justify-content: flex-start;
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;

export const SemanticButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }

  transition: all 0.6s;
`;

export const LinkRedirect = styled(Link)`
  color: #2185d0 !important;
  cursor: default;

  &:hover {
    text-decoration: none;
    color: #2d8cd4 !important;
  }
`;
